import { FC } from 'react'
import { HeaderButtonControl } from './HeaderButtonControl'

export const HeaderCoffeeButton: FC = () => {
  return (
    <HeaderButtonControl>
      <a
        className="bg-yellow-300 text-zinc-700 hover:bg-yellow-400 hover:text-zinc-800 active:bg-yellow-500 active:text-zinc-900 active:shadow-none"
        href="https://www.buymeacoffee.com/alexchuev"
        target="_blank"
        rel="nofollow noreferrer noopener"
      >
        Buy Me a Coffee
      </a>
    </HeaderButtonControl>
  )
}
